import { FC, ReactNode } from 'react'
import * as cn from 'classnames'
import SvgIcon from 'components/atoms/SvgIcon'
import ChevronSvg from 'icons/chevron.svg'
import ReactSvgIcon from 'icons/*.svg'

import * as styles from 'components/features/insights/Insight/Badge.css'

export type BadgeTheme = 'golden' | 'blue' | 'gray' | 'warning' | 'alert' | 'success' | 'info' | 'fresh'

type BadgeProps = {
  nodeId?: string
  withChevron?: boolean
  isExpanded?: boolean
  isFaded?: boolean
  children: ReactNode
  theme: BadgeTheme
  size?: 'regular' | 'small'
  icon?: typeof ReactSvgIcon
  onClick?: () => void
}

const Badge: FC<BadgeProps> = (props) => {
  const { withChevron, isExpanded, isFaded, children, theme, size = 'regular', icon, nodeId, onClick } = props
  const badgeClassName = cn(styles.badge, styles[theme], {
    [styles.expanded]: isExpanded,
    [styles.faded]: isFaded,
    [styles.withChevron]: withChevron,
  })

  const iconChild = icon
    ? (
      <div className={ styles.iconWrapper }>
        <div className={ styles.icon }>
          <SvgIcon src={ icon } />
        </div>
      </div>
    )
    : null

  const chevronChild = withChevron
    ? (
      <div className={ styles.chevron }>
        <SvgIcon src={ ChevronSvg } />
      </div>
    )
    : null

  return (
    <div className={ badgeClassName } onClick={ onClick } id={ nodeId }>
      { iconChild }
      <div className={ cn(styles.background, styles[size]) }>
        <span className={ styles.text }>
          { children }
          { chevronChild }
        </span>
      </div>
    </div>
  )
}

export default Badge
